import lrInputColor from './_src/lrInputColor.vue'

lrInputColor.install = function(Vue) {
  Vue.component(lrInputColor.name, lrInputColor)
}

export default lrInputColor